import { BrowserRouter } from "react-router-dom";
import TransitionLayer from "./components/TransitionLayer";
import Header from "./components/Header/Header";
import Footer from "./components/Footer";
import AppRouter from "./components/AppRouter";
import "./css/App.css";
import "./css/media-app.css";
import ScrollToTopButton from "./components/ScrollToTop";
import { CookiesProvider, useCookies } from "react-cookie";
import { useEffect, useMemo } from "react";
import userStore from "./store/userStore";
import userApi from "./api/userApi";
import { apiHelpers } from "./utils/apiHelpers";
import { fetchWithAbort } from "./utils/fetchWithAbort";
import { scripts } from "./utils/scripts";

function App() {
  //useSmoothScroll();

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    (async () => {
      try {
        // Выполнение запросов параллельно
        const [userData, basketData] = await Promise.all([
          fetchWithAbort((signal) => userAuth(signal), signal),
          fetchWithAbort(
            (signal) => apiHelpers.getAndSetUserBasket(signal),
            signal
          ),
        ]);

        // Обработка данных (если нужно)
        console.log("User Data:", userData);
        console.log("Basket Data:", basketData);
      } catch (err) {
        console.error("An error occurred:", err);
      }
    })();

    return () => {
      controller.abort(); // Отмена всех запросов при размонтировании
    };
  }, []);

  // Метод входа в аккаунт
  async function userAuth(signal) {
    try {
      if (!userStore.isAuth) {
        const userData = await userApi.getUserInfo(signal);
        if (userData) {
          userStore.setIsAuth(true);
          userStore.setData(userData);
        }
        return userData; // Возвращаем данные
      }
    } catch (err) {
      console.error("User auth error:", err);
      throw err; // Пробрасываем ошибку
    }
  }

  useEffect(() => {
    scripts();
  }, []);

  return (
    <CookiesProvider>
      <BrowserRouter>
        <TransitionLayer />
        <div className="page-container">
          <Header />
          <AppRouter />
          <Footer />
        </div>
        <ScrollToTopButton />
        <div id="notification-container"></div>
        <div id="modal-container"></div>
        <div id="offcanvas-container"></div>
      </BrowserRouter>
    </CookiesProvider>
  );
}

export default App;
